import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';

const useBizCategoryTree = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [bizCateTree, setBizCateTree] = useState<BizCategoryTreeDto[] | any[]>();
    
  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading, refetch } = useQuery(
    [endpoints.refcode.bizlist],
    () =>
      fetcher.refcode.getBizCategoryTree(),
    {
      onSuccess: (res: BizCategoryTreeResDto) => {
        switch (res.code) {
          case 200:
            setBizCateTree(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  ); 

  return { isLoading, bizCateTree };
};

export default useBizCategoryTree;
